import React from "react";
import styled from "styled-components";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import ChartCard from "../ui/Card/ChartCard";
import { CardBody, CardUnit, CardValue } from "../ui/Card/Card";
import GaugeStat from "../ui/GaugeStat/GaugeStat";
import SplitBar from "../ui/SplitBar/SplitBar";
import MiniMetric from "../ui/MiniMetric/MiniMetric";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { SECTIONS } from "../../constants";
import { fmt1, fmt1Signed } from "../../functions/format";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.temps;

const SKELETON_ROWS = [{ cols: 3, cards: [3, 3, 3] }];

const TempsSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const surTheorique = data.pctRealise > 100;

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                <ChartCard title="Heures réalisées" fill>
                    <Fill>
                        <GaugeStat
                            pct={Math.min(100, data.pctRealise)}
                            color={
                                surTheorique
                                    ? CHART_COLORS.amber
                                    : CHART_COLORS.violet
                            }
                            unit="%"
                            sub="du théorique"
                            value={fmt1(data.pctRealise)}
                            tip={`${fmt1(
                                data.pctRealise
                            )} % du théorique (${fmt1Signed(
                                data.ecartTheorique
                            )} h)`}
                        />
                    </Fill>
                    <MiniMetric
                        mt="10px"
                        label="Écart vs théorique"
                        value={`${fmt1Signed(data.ecartTheorique)} h`}
                    />
                </ChartCard>

                <ChartCard title="Heures supplémentaires" fill>
                    <CardBody>
                        <CardValue>
                            {fmt1(data.heuresSup)}
                            <CardUnit>h</CardUnit>
                        </CardValue>
                    </CardBody>
                    <MiniMetric
                        mt="10px"
                        label="Cumul période"
                        value={`${fmt1(data.heuresSup)} h`}
                    />
                </ChartCard>

                <ChartCard title="Télétravail" fill>
                    <Fill $center>
                        <SplitBar
                            noMargin
                            left={{
                                label: "Télétravail",
                                value: `${fmt1(data.telePct)}%`,
                                pct: data.telePct,
                                tip: `Télétravail : ${fmt1(data.telePct)} %`,
                            }}
                            right={{
                                label: "Présentiel",
                                value: `${fmt1(data.presentielPct)}%`,
                                tip: `Présentiel : ${fmt1(
                                    data.presentielPct
                                )} %`,
                            }}
                        />
                    </Fill>
                    <MiniMetric
                        mt="10px"
                        label="Moyenne"
                        value={`${fmt1(data.teleJours)} j/collab.`}
                    />
                </ChartCard>
            </Grid>
        </Section>
    );
};

export default TempsSection;

const Fill = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: ${({ $center }) => ($center ? "center" : "flex-start")};
`;
